
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M53 27.7v-.9c0-.5-.5-.9-1-.9h-.5l.9-1.5c.2-.3.2-.6.1-.9-.1-.3-.3-.5-.6-.6-3-1.1-4.7-1.7-5-1.7-.4-.1-.9.2-1.1.6l-.3.7v-.3c0-.4-.3-.7-.7-.9l-3.7-1.1c-.3-.1-.7 0-.9.2l-.6.6c-.3-1-.7-2-1.1-2.9-.4-.9-.8-1.8-1-2.7v-.1c0-.1 0-.1-.1-.2 0-.1-.1-.1-.1-.2l-.1-.1c-.1 0-.1-.1-.2-.1h-.4-.1-.1c-.1 0-.1 0-.1.1 0 0-.1 0-.1.1-.1 0-.1.1-.2.1 0 0-.1 0-.1.1-.1.1-.1.2-.2.3 0 .1-.1.2-.1.3-.3.7-2.6 4.6-6.8 4.3-1.9-.1-3.7.4-5.1 1.2-.6-3.9-4.9-6.2-7.5-7.5l-.3-.1c-2.5-1.2-3.1-2.1-3.1-2.1 0-.1-.1-.2-.2-.3 0 0-.1 0-.1-.1-.1 0-.1-.1-.2-.1h-.4-.1c-.1 0-.2.1-.3.1-.2.1-.2.2-.3.2 0 0 0 .1-.1.1 0 .1-.1.1-.1.2v.2c-.1.3-.4 1-.7 1.7-1.4 2.9-3.8 7.9-1.1 12.3H8c-.5 0-1 .4-1 .9v.9c0 6.7 3.9 12.9 10.3 16.6v2.6c0 1 .8 1.8 1.8 1.8h21.7c1 0 1.8-.8 1.8-1.8v-2.6C49.1 40.6 53 34.5 53 27.7zm-5.7-4.2c.7.2 1.7.5 2.7.9l-.9 1.5h-2.7l.9-2.4zM41 22.4l2.6.8.3 2.7h-4.5c.5-.8.6-1.7.6-2.6l1-.9zM28.6 22c2.5.2 4.9-.8 6.9-2.8.1-.1.3-.3.4-.5 0 1.1-.1 2.2-.8 3-.7.9-2.1 1.4-4.1 1.5-.6 0-1 .5-.9 1.1 0 .5.5.9 1 .9h.1c2.5-.1 4.4-.9 5.5-2.3.4-.5.7-1.1.9-1.7.7 2.3.6 3.6-1 4.6H22.1c.1-.3.3-.7.6-1.2 1-1.3 3.2-2.8 5.9-2.6zm-17.1-6.5c1.1 4.5 3.2 7 3.6 7.5.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.5-1 .1-1.4-.3-.3-2.3-2.8-3.3-7.2.5.3 1 .6 1.7.9l.2.1c3.6 1.8 7 3.9 6.4 7.3-.3.4-.7.8-.9 1.1-.4.6-.6 1.2-.7 1.8h-8.3c-2.9-2.8-1.8-6.5-.2-10.1zm9.6 12.3c.1 0 0 .1 0 0H51c0 1-.1 2-.3 2.9H9.3c-.2-1-.3-1.9-.3-2.9h12.1zm19.6 18.9H19.3v-1.9h21.3v1.9h.1zm.6-3.9H18.7c-4.3-2.4-7.4-5.9-8.8-10h40.3c-1.5 4.1-4.5 7.6-8.9 10z"}})])
          )
        }
      }
    